import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../../api/api.config";

export interface OneDriveCredential {
  _id: string;
  user_info: {
    user_email: string;
    user_name: string;
  };
  id: string;
}

export interface OneDriveFolder {
  id: string;
  name: string;
  childCount: number;
  path: string;
  children: any[];
}

const oneDriveService = {
  getOneDriveLoginUrl: (templateId?: string) => {
    const baseUrl = `${API_BASE_URL}${API_ENDPOINTS.ONEDRIVE_CONNECTOR.LOGIN}`;
    return templateId ? `${baseUrl}?template_id=${templateId}` : baseUrl;
  },

  listCredentials: async (templateId?: string | null) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.ONEDRIVE_CONNECTOR.LIST_CREDENTIALS}`,
        {
          params: { template_id: templateId }
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error listing OneDrive credentials:", error);
      throw error;
    }
  },

  listFolders: async (credentialId: string, templateId?: string | null) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.ONEDRIVE_CONNECTOR.LIST_FOLDERS}`,
        {
          credential_id: credentialId,
          template_id: templateId
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error listing OneDrive folders:", error);
      throw error;
    }
  },
};

export default oneDriveService;